import { OrganizationTheme } from '../../models/theme.interface';
import { doenkidsTheme } from './doenkids.theme';
import { beinspiredTheme } from './beinspired.theme';
import { ovivioTheme } from './ovivio.theme';

/**
 * Theme Registry
 *
 * All available organization themes are registered here.
 * The ThemeService uses this registry to find the appropriate theme
 * based on the current domain.
 *
 * To add a new organization:
 * 1. Create a new theme file (e.g., neworg.theme.ts)
 * 2. Import it here
 * 3. Add it to the AVAILABLE_THEMES array
 */
export const AVAILABLE_THEMES: OrganizationTheme[] = [
  doenkidsTheme,
  beinspiredTheme,
  ovivioTheme,
];

/**
 * Default theme to use if no matching domain is found
 */
export const DEFAULT_THEME = doenkidsTheme;

/**
 * Export individual themes for direct access
 */
export { doenkidsTheme, beinspiredTheme, ovivioTheme };
